
export class ConfirmEmail   {
	public code: string;
}